<template>
 <a-form v-if="advice" ref="form" :model="advice" :rules="rules" layout="vertical">
  <a-row :gutter="30">
   <a-col :md="12" :xs="24" class="mb-2">
    <a-form-item label="Wil de klant advies over isolatie en de bijbehorende subsidie?" name="wanted">
     <a-radio-group v-model:value="advice.wanted" button-style="solid">
      <a-radio-button :value="true">Ja</a-radio-button>
      <a-radio-button :value="false">Nee</a-radio-button>
     </a-radio-group>
    </a-form-item>
   </a-col>
   <a-col :md="12" :xs="24" class="mb-2">
    <a-form-item label="Zijn er isolatiemaatregelen van toepassing?" name="measuresApplicable">
     <a-radio-group v-model:value="advice.measuresApplicable" button-style="solid">
      <a-radio-button :value="true">Ja</a-radio-button>
      <a-radio-button :value="false">Nee</a-radio-button>
     </a-radio-group>
    </a-form-item>
   </a-col>
  </a-row>
 </a-form>
</template>

<script>
import {computed, ref} from "vue";
import {useStore} from "vuex";

const answered = message => [{
 required: true,
 message,
 validator: async (_rule, value) => {
  if (value !== true && value !== false) throw new Error(message);
 },
 trigger: 'change',
}];

const rules = {
 wanted: answered('Kies ja of nee'),
 measuresApplicable: answered('Kies ja of nee'),
};

const IsolationAdvice = {
 name: 'IsolationAdvice',
 setup() {
  const {state} = useStore();
  const form = ref();

  const advice = computed(() => {
   const x = state.shop.order?.extraData;
   if (!x) return null;
   if (!x.isolationAdvice) {
    x.isolationAdvice = {wanted: null, measuresApplicable: null};
   }
   return x.isolationAdvice;
  });

  // Aangeroepen door de flow voor de volgende stap
  const validate = () => (form.value ? form.value.validate() : Promise.resolve());

  return {
   form,
   rules,
   advice,
   validate,
  };
 },
};

export default IsolationAdvice;
</script>
